module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-800@2x-a5b5ed6cf8eedb47f73c7960d690e40b.webp";